var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-img"},[(_vm.status)?_c('img',{class:_vm.status,attrs:{"src":_vm.img(_vm.imgPath)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }